import {FilterSelect} from "../Select/FilterSelect";
import {usePageDataContext} from "../../contexts/PageDataContext";

export function PupilSchoolYearSelector({onChange, ...filterSelectProps}) {
    const {schoolYearOptions, getDefaultSchoolYearValue, handleSchoolYearChange, couldShowSchoolYearSelector} = usePageDataContext();

    if (!couldShowSchoolYearSelector) return null;

    return (
        <FilterSelect
            options={schoolYearOptions}
            placeholder="Schooljaar"
            onChange={onChange ?? handleSchoolYearChange}
            defaultValue={getDefaultSchoolYearValue}
            {...filterSelectProps}
        />
    );
}
